export default {

    // APPLICATIONS
    ADD_APPLICATION: {
        url: "/api/v1/applications",
        method: "post",
    },
    ADD_APPLICATION_VIA_QRCODE: {
        url: "/api/v1/applications/qr",
        method: "post",
    },
    GET_APPLICATIONS: {
        url: "/api/v1/applications",
        method: "get",
    },
    GET_APPLICATION_BY_ID: {
        url: "/api/v1/applications/{applicationLeadId}",
        method: "get",
    },
    UPDATE_APPLICATION: {
        url: "/api/v1/applications/{applicationLeadId}",
        method: "put",
    },
    DELETE_APPLICATION: {
        url: "/api/v1/applications/{applicationLeadId}",
        method: "delete",
    },
}